/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsContainerFindingsSeverityQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AppSecopsContainerFindingsSeverityQueryOperator");
    }

    getFixupPrototypeFunction() { return AppSecopsContainerFindingsSeverityQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsContainerFindingsSeverityQueryOperator>): AppSecopsContainerFindingsSeverityQueryOperator {
        let obj = Object.assign(new AppSecopsContainerFindingsSeverityQueryOperator(), model);
        AppSecopsContainerFindingsSeverityQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsContainerFindingsSeverityQueryOperator>): AppSecopsContainerFindingsSeverityQueryOperator {
        if (!model) return null;
        return AppSecopsContainerFindingsSeverityQueryOperator.newInstance(<AppSecopsContainerFindingsSeverityQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsContainerFindingsSeverityQueryOperator) {
        if (!obj) return;

        models.AppSecopsContainerFindingsSeverityQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsContainerFindingsSeverityQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsContainerFindingsSeverityQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Finding severity to include
     */
    severities: Array<models.SecurityFindingsSeverity>;

}
